import { createRoute, Outlet, redirect } from "@tanstack/react-router";
import { OscarSearchPage } from "pages/app/OscarSearchPage";

import { currentUserQueryOptions } from "lib/hooks/api/users/useCurrentUser";
import { rootRoute } from "../rootRoute";

// Pathless layout that gates every admin tool behind an admin check. This is a
// client-side convenience guard only — non-admins are redirected home rather
// than shown the tool; it is not a substitute for server-side authorization.
export const adminToolsGuardRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: "_adminToolsGuard",
  staticData: { pageName: "" },
  beforeLoad: async ({ context }) => {
    const data = await context.queryClient.ensureQueryData(
      currentUserQueryOptions(context.graphQLClient),
    );
    if (!data.currentUser?.isAdmin) {
      throw redirect({ to: "/" });
    }
  },
  component: Outlet,
});

export const oscarSearchRoute = createRoute({
  getParentRoute: () => adminToolsGuardRoute,
  path: "/oscar_search",
  staticData: { pageName: "Oscar Search" },
  component: OscarSearchPage,
});

export const adminToolsRouteTree = adminToolsGuardRoute.addChildren([oscarSearchRoute]);
